import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [SelectComponent],
  exports: [SelectComponent],
  imports: [CommonModule, AngularSvgIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectModule {}
